import { withCache } from './withCache';

export default withCache;
